import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import GroupField from '../forms/group-field';
import MaterialLink from '../material-link';

const useStyles = makeStyles((theme) => ({
  field: {
    marginBottom: theme.spacing(1),
  },
}));

const EventFormGroup = ({ disabled, forceTouched, ...rest }) => {
  const classes = useStyles();

  return (
    <GroupField
      name="groupId"
      label="Group"
      disabled={disabled}
      touched={forceTouched}
      helperText={(
        <MaterialLink href="/groups/new" target="_blank">
          Create a Group
        </MaterialLink>
      )}
      placeholder="No Group"
      className={classes.field}
      permission="createEvent"
      {...rest}
    />
  );
};

EventFormGroup.propTypes = {
  disabled: PropTypes.bool.isRequired,
  forceTouched: PropTypes.bool.isRequired,
};

export default EventFormGroup;
